import { ProductModel } from "../../products-categories/models/product.model";
import {Injectable, ViewChild} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {MatSidenav} from "@angular/material/sidenav";
import {ProductsService} from "../../products-categories/services/products.service";

@Injectable({
  providedIn: 'root'
})

export class CartService {

  public drawercart!: MatSidenav;

  items: ProductModel[] = [];

  //Count items
  //itemsInCart: BehaviorSubject<number> = new BehaviorSubject(0);
  itemsInCart$: BehaviorSubject<ProductModel[]> = new BehaviorSubject<ProductModel[]>([]);
  itemsInCartCount$: Observable<number>;


  constructor(private productService: ProductsService) {
    this.itemsInCartCount$ = this.itemsInCart$.pipe(map(items => items?.length ?? 0));

    this.itemsInCartCount$.subscribe(count => {
      if(count==0 && this.drawercart)  {
        this.drawercart.close();
      }
    })
    this.refreshCartItems();

  }

  addToCart(product: ProductModel) {
    this.loadCart();
    let its = this.getItems();
    if(its) {
      this.items = its;
    }

    this.items.push(product);
    this.saveCart();

    this.updateCountItems();

  }

  countItems() {
    return this.getItems()?.length ?? 0;
  }

  //Send to
  updateCountItems() {
    this.itemsInCart$.next(this.getItems());
  }

  getItems() {
    let items = localStorage.getItem('cart_items') as string;
    if(items == '[]') {
      //Remove local storage
      this.clearCart();
    }

    return JSON.parse(localStorage.getItem('cart_items') as string);
  }


  clearCart() {
    this.items = [];
    localStorage.removeItem("cart_items")
    this.updateCountItems();
    return this.items;
  }

  loadCart(): void {
    return JSON.parse(localStorage.getItem('cart_items') as string);
  }

  saveCart(): void {

    localStorage.setItem('cart_items', JSON.stringify(this.items));
  }

  itemInCart(item:any) {
    let items = this.getItems();
    let exist = false;
    if(items) {
      for (let o of items) {
        if (o.id == item.id) {
          exist = true
        }
      }
    }

    return exist;
  }

  deleteItemInCart(item:any) {
    let items = this.getItems();
    if(items) {
      let i = 0;
      for (let o of items) {
        if (o.id == item.id) {
          items.splice(i, 1);
        }
        i++;
      }
    }

    this.loadCart();
    this.items = items;
    this.saveCart();
    this.updateCountItems();
  }


  refreshCartItems() {
    const currentLang = localStorage.getItem('language') || 'en'; // Langue actuelle
    const currentItems: ProductModel[] = this.getItems();  // Assurer que currentItems est un tableau de ProductModel

    console.log("currentItems", currentItems);

    if (currentItems) {
      // Appel au service pour récupérer les produits
      this.productService.getProductsFromServer('all').subscribe({
        next: (products: ProductModel[]) => {  // On attend bien un tableau de produits ici
          if (Array.isArray(products)) {
            console.log("Updated productsproductsproducts:", products);
            // Initialisation de updatedItems après récupération des produits
            const updatedItems = currentItems.map((item: ProductModel) => {
              // Recherche du produit correspondant dans le tableau des produits
              const product = products.find(p => p.id === item.id);

              if (product) {
                // Si le produit est trouvé, on remplace l'item avec les données du produit
                return {
                  ...item,  // Garde les propriétés actuelles
                  ...product,  // Remplace par les nouvelles données du produit
                };
              }

              return item;  // Si le produit n'est pas trouvé, on garde l'item original
            });

            console.log("Updated Items:", updatedItems);
            // Mets à jour les produits dans le panier
            this.itemsInCart$.next(updatedItems);
            this.items = updatedItems; // Met à jour l'instance de `items`
            this.saveCart();  // Sauvegarde les produits mis à jour dans localStorage
          } else {
            console.error('La réponse n\'est pas un tableau valide de produits.');
          }
        },
        error: (error) => {
          console.error('Erreur lors du chargement des produits:', error);
        }
      });
    }
  }





}
